import React, { useEffect, useState } from 'react';
import Seo from '../../../Components/SeoComponent/Seo';
import Header from '../../../Components/Header';
import { Button, InputWithLabel } from '../../../Components/Tags/Tags';
import Loader from '../../../Loader';
import { companyCinVerifyService, fetchProfile } from '../../../Services/ApiTestService/aadharTestService';
import { showErrorToast, showSuccessToast } from '../../../utils/toastUtils';
import { cinData } from '../Data';
import { FaBuilding, FaUserTie, FaMoneyBill, FaEnvelope, FaMapMarkerAlt, FaCalendarAlt, FaCopy } from 'react-icons/fa';
import { Link } from "react-router-dom";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import { useService } from '../../../context/ServiceContext';


const CompanyCinVerfication = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [cin, setCin] = useState('');
    const [message, setMessage] = useState({ message: "", type: "error" });
    const [profileData, setProfileData] = useState({});
    const [companyData, setCompanyData] = useState(null);
    const { serviceName } = useService();

    async function handleSubmit() {
        if (cin === "") {
            setMessage({ message: "Company CIN required.", type: "error" });
            return;
        }

        setIsLoading(true);
        try {
            setMessage({ message: "Verifying CIN...", type: "success" });
            const payload = {
                api_id: profileData?.user_id,
                api_key: profileData?.api_key,
                token_id: profileData?.token_id,
                cin: cin
            };
            let response = await companyCinVerifyService({ payload });
            if (response.status.code === 200) {
                setIsLoading(false);
                showSuccessToast(response.message);
                setMessage({ message: response?.message, type: "success" });
                setCompanyData(response.data);
                setCin('');
            } else {
                setIsLoading(false);
                showErrorToast(response.message || response.data.message || response.error.message || "Something went wrong.");
                setMessage({ message: "Something went wrong. Please try again.", type: "error" });
            }
        } catch (error) {
            setIsLoading(false);
            setMessage({ message: "Something went wrong. Please try again.", type: "error" });

        }
    }

    useEffect(() => {
        const fetchProfileData = async () => {
            try {
                setIsLoading(true);
                const response = await fetchProfile();
                setProfileData(response.data);
            } catch (error) {
                console.error("Error fetching profile data:", error);
                showErrorToast("Failed to fetch profile data.");
            } finally {
                setIsLoading(false);
            }
        };

        fetchProfileData();
    }, []);


    const renderCompanyCard = () => {
        if (!companyData?.details) {
            return (
                <div className="text-center p-4 bg-red-100 border border-red-300 text-red-700 rounded">
                    No company data available.
                </div>
            );
        }

        const { company_info = {}, directors = [], charges = [] } = companyData.details;

        return (
            <div className="relative bg-white/70 backdrop-blur-lg border border-blue-100 p-6 rounded-2xl shadow-xl max-w-2xl mx-auto">
                {/* Decorative Chip */}

                <div className="absolute top-4 right-4 w-10 h-6 bg-yellow-400 rounded-sm shadow-inner" />
                <div className="mb-4 flex items-center gap-2">
                    <FaBuilding className="text-blue-600 text-xl" />
                    <h2 className="text-2xl font-bold text-blue-900">
                        {companyData?.company_name || "Company Name Not Available"}
                    </h2>
                </div>

                <div className="text-gray-700 text-sm space-y-2">
                    <p className="flex items-center gap-2">
                        <span className="text-gray-500"><FaCalendarAlt /></span>
                        <strong>Incorporated:</strong> {company_info?.date_of_incorporation || "N/A"}
                    </p>
                    <p className="flex items-center gap-2">
                        <span className="text-gray-500"><FaMoneyBill /></span>
                        <strong>Status:</strong> {company_info?.company_status || "N/A"}
                    </p>
                    <p className="flex items-center gap-2">
                        <span className="text-gray-500"><FaEnvelope /></span>
                        <strong>Email:</strong> {company_info?.email_id || "Not Provided"}
                    </p>
                    <p className="flex items-center gap-2">
                        <span className="text-gray-500"><FaMapMarkerAlt /></span>
                        <strong>Address:</strong> {company_info?.registered_address || "Not Available"}
                    </p>
                    <p className="text-xs italic text-blue-500">
                        CIN: {company_info?.cin || "Unavailable"}
                    </p>
                </div>


                <div className="mt-6">
                    <h3 className="text-md font-semibold text-blue-700 mb-1 flex items-center gap-1"><FaUserTie /> Directors</h3>
                    {Array.isArray(directors) && directors.length > 0 ? (
                        <ul className="list-disc ml-6 text-gray-800 text-sm space-y-1">
                            {directors.map((director, idx) => (
                                <li key={idx}>
                                    {director?.director_name || "Name not available"}
                                    <span className="text-gray-500"> (DIN: {director?.din_number || "N/A"})</span>
                                </li>
                            ))}
                        </ul>
                    ) : (
                        <p className="text-sm text-gray-500 italic ml-2">No directors available.</p>
                    )}
                </div>


                <div className="mt-6">
                    <h3 className="text-md font-semibold text-blue-700 mb-1 flex items-center gap-1"><FaMoneyBill /> Charges</h3>
                    {Array.isArray(charges) && charges.length > 0 ? (
                        <ul className="list-disc ml-6 text-gray-800 text-sm space-y-1">
                            {charges.map((charge, idx) => (
                                <li key={idx}>
                                    <strong>Status:</strong> {charge?.status || "N/A"},
                                    <strong className="ml-1">Amount:</strong> ₹{charge?.charge_amount || "0"},
                                    <strong className="ml-1">Assets:</strong> {charge?.assets_under_charge || "N/A"}
                                </li>
                            ))}
                        </ul>
                    ) : (
                        <p className="text-sm text-gray-500 italic ml-2">No charges listed.</p>
                    )}
                </div>
            </div>
        );
    };

    function handleCopyText(data) {
        window.navigator.clipboard.writeText(JSON.stringify(data));
        showSuccessToast('Copied successfully')
    }

    return (
        <div className="p-4">
            <Seo title={serviceName} />
            <Header heading={serviceName} />
            {isLoading && <Loader />}

                  
                  <div className="col-span-2 md:col-span-6 flex justify-end">
              <Link
                to="/TestMaster"
                className="flex items-center gap-1 text-white bg-green-600 hover:bg-green-700 px-1 py-1 rounded-md font-semibold shadow-md transition duration-300"
              >
                <span>Go Back</span>
                <IoArrowBackCircleOutline size={24} />
              </Link>
            </div>

            <div className='flex items-end gap-2'>

                <div>
                    <InputWithLabel
                        label={"CIN"}
                        placeholder={"Enter CIN number."}
                        required={true}
                        value={cin}
                        onChange={(e) => setCin(e.target.value)}
                    />
                    <span className={`${message.type === "error" ? 'text-red-800' : 'text-green-500'}`}>{message.message}</span>
                </div>
                <Button text={'Verify'} type={'button'} onClick={handleSubmit} />
            </div>

            {companyData && (
                <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>{renderCompanyCard()}</div>
                    <pre className="bg-black relative text-green-500 p-4 rounded text-sm overflow-auto max-h-[600px]">
                    <FaCopy className="absolute top-2 cursor-pointer right-2  bg-white p-1 rounded-md font-bold text-2xl" onClick={()=>handleCopyText(companyData)} />
                        {JSON.stringify(companyData, null, 2)}
                    </pre>
                </div>
            )}
        </div>
    );
};

export default CompanyCinVerfication;
